import clsx from 'clsx';
import { KeyboardEvent, useCallback } from 'react';

import { KeyCode } from '@vestico/utils';

import globalStyle from '@vestico/shared/src/layouts/utils.module.css';

import style from './radioButton.module.css';

export interface RadioButtonProps {
  groupId: string;
  id: string;
  displayValue: string;
  checked: boolean;
  didTrigger?: (id: string) => void;
  disabled?: boolean;
  flexibleWidth?: boolean;
}

export const RadioButton = ({ groupId, id, checked, displayValue, didTrigger, disabled, flexibleWidth }: RadioButtonProps) => {
  const onSelect = useCallback(() => {
    if (!disabled && didTrigger) {
      didTrigger(id);
    }
  }, [disabled, didTrigger, id]);

  const handleKeyUp = useCallback(
    (e: KeyboardEvent<HTMLDivElement>) => {
      e.preventDefault();
      e.stopPropagation();

      if (!disabled && didTrigger && e.code === KeyCode.enter) {
        didTrigger(id);
      }
    },
    [disabled, didTrigger, id]
  );

  return (
    <div
      className={clsx(style.buttonContainer, { [style.flexibleWidth]: flexibleWidth, [style.disabled]: disabled })}
      onClick={onSelect}
      onKeyUp={disabled ? undefined : handleKeyUp}
      role="button"
      tabIndex={0}
    >
      <span className={clsx(style.radio__input)}>
        <input type="radio" id={id} value={displayValue} name={groupId} checked={checked} onChange={onSelect} />
        <span className={clsx(style.radio__control)} />
      </span>
      <label className={clsx(globalStyle.textNormal)} htmlFor={id}>
        {displayValue}
      </label>
    </div>
  );
};

export default RadioButton;
